const barcode = {
  CODE_39: 'code39',
  QR_CODE: 'qrcode',
};

export default barcode;
